import { render, staticRenderFns } from "./IncomeStatementEditor.vue?vue&type=template&id=12281b3d&"
import script from "./IncomeStatementEditor.vue?vue&type=script&lang=js&"
export * from "./IncomeStatementEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports